import { atom } from "jotai";

export const entrevistaAtom = atom(undefined)